export default class PrintPageController {
    public static readonly controllerName = 'PrintPageCtrl';

    public url: string;

    public init(model) {
        this.url = model.url;
    }
}
